import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const ConfirmDeleteDialog = ({
  open,
  title,
  message,
  showReason,
  reason,
  onReasonChange,
  onCancel,
  onConfirm,
}) => {
  const handleConfirm = () => {
    if (showReason && !reason.trim()) return;
    onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          border: "1px solid #dcdcdc",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        },
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleConfirm();
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText>{message}</DialogContentText>

        {showReason && (
          <TextField
            autoFocus
            fullWidth
            required
            margin="dense"
            label="Reason"
            multiline
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            size="small"
            sx={{
              "& .MuiInputBase-root": {
                height: "60px",
                alignItems: "flex-start",
              },
            }}
            inputProps={{
              style: {
                height: "40px",
                overflow: "auto",
              },
            }}
          />
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "16px" }}>
        <Button
          onClick={onCancel}
          className="p-2 my-2 bg-primary text-white rounded"
          variant="contained"
        >
          Cancel
        </Button>

        <Button
          onClick={handleConfirm}
          disabled={showReason && !reason.trim()}
          className="p-2 my-2 bg-danger text-white rounded"
          variant="contained"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
